import ReactDOM from "react-dom";

export const renderToString = (Element: JSX.Element) => {
    const container = document.createElement("div");
    ReactDOM.render(Element, container);
    const html = container.innerHTML;
    ReactDOM.unmountComponentAtNode(container);
    return html;
};
